export enum PageTypeEnum {
  EnquiryManager = "Enquiry Manager",
  TaskManager = "Task Manager",
  LeadManager = "Lead Manager",
  UserDirectory = "User Directory",
}
